import React, { useContext } from 'react'
import { Grid, GridItem, Button } from '@deal/components'
import { AnalyticsContext } from '#src/containers/Analytics'
import { useNavItemContext } from '../TopLevelNavItem/NavItemContext'
import { Link } from 'react-router-dom'
import { useDesktopJournalNavigationQuery } from '../../../DesktopJournalNavigation.generated'
import ArticleCard from '#src/components/ArticleCard'
import styles from './styles.css'

const JournalMenu: React.FC = () => {
  const analytics = useContext(AnalyticsContext)
  const navItemContext = useNavItemContext()
  const { data } = useDesktopJournalNavigationQuery({
    variables: {
      limit: 6
    }
  })

  return (
    <div className={styles.menu} data-testid="desktop-journal-menu">
      <Grid wrapperClassName={styles.wrapper}>
        {data && data.articleTopLevelNavigation && (
          <>
            {data.articleTopLevelNavigation.sections.map(navSection => {
              const firstArticle = navSection.articles[0]

              return (
                <GridItem
                  col={2}
                  mdCol={2}
                  className={styles.column}
                  key={navSection.id}
                  data-testid="desktop-journal-card"
                >
                  <div className={styles.sectionHeader}>{navSection.displayName}</div>
                  <ArticleCard
                    article={firstArticle}
                    sizes="25vw"
                    onClick={() => {
                      analytics?.events.trackArticleEntryPointClicked({
                        article_id: firstArticle.articleId,
                        entry_point: 'header'
                      })
                      navItemContext?.onNavItemSelected()
                    }}
                    hideSummary
                  />
                </GridItem>
              )
            })}
            <GridItem col={2} className={styles.viewAll}>
              <Link
                to="/journal"
                onClick={() => {
                  analytics?.events.trackArticleHubEntryPointClicked({
                    entry_point: 'header'
                  })
                  navItemContext?.onNavItemSelected()
                }}
                data-testid="desktop-journal-view-all"
              >
                <Button size="small" variant="contrast-outline">
                  View all
                </Button>
              </Link>
            </GridItem>
          </>
        )}
      </Grid>
    </div>
  )
}

export default JournalMenu
